import React, { useState, useEffect } from 'react';
import { getAPI } from '../../../app/api';
import { store } from '../../../app/store';

// HTML Assets Base URL
const HTML_ASSETS_URL = 'https://retechprime.com/be-college-ex-students-club/html/';

export default function SearchAlumniDirectory() {
    const [FormData, setFormData] = useState({
        username: '',
        access_token: '',
        name: ''
    });
    const store_data = JSON.parse(store());
    const [Loading, setLoading] = useState(false);
    const [SearchStatus, setSearchStatus] = useState(null);
    const [AlumniData, setAlumniData] = useState(null);
    const [hasSearched, setHasSearched] = useState(false);

    useEffect(() => {
        setFormData({
            username: store_data?.email_id || '',
            access_token: store_data?.access_token || '',
            name: ''
        })
    }, [store_data?.is_login])

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...FormData,
            [name]: value
        });
    }

    const handleSearch = async () => {
        setHasSearched(true);
        if (!FormData.name) {
            setSearchStatus({ status: 0, msg: "Please enter a name to search." });
            setAlumniData([]);
            return;
        }
        setLoading(true);
        try {
            const data = await getAPI(`alumni/search?name=${encodeURIComponent(FormData.name)}`);
            if (Array.isArray(data) && data.length > 0) {
                setAlumniData(data);
                setSearchStatus({ status: 1, msg: "Alumni found successfully" });
            } else {
                setAlumniData([]);
                setSearchStatus({ status: 0, msg: "No alumni found" });
            }
        } catch (e) {
            setAlumniData([]);
            setSearchStatus({ status: 0, msg: e.message || "An error occurred" });
        } finally {
            setLoading(false);
        }
    };

    // Clear search input and results
    const handleClear = () => {
        setFormData({ ...FormData, name: '' });
        setAlumniData(null);
        setSearchStatus(null);
        setHasSearched(false);
    };

    return (
        <>
            <section className="alumni csalm mt-5">
                <div className="container">
                    <div className="search-box p-4 mb-5">
                        <h3>Search Alumni Directory</h3>
                        <div className="row g-3 align-items-center">
                            <div className="col-lg-6 col-md-6 col-sm-12">
                                <div className="input-group mb-3">
                                    <input
                                        type="text"
                                        className="form-control search-input"
                                        placeholder="Search by name, passout year, or discipline"
                                        name="name"
                                        value={FormData.name}
                                        onChange={handleChange}
                                        onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                                    />
                                    <span className="input-group-text">
                                        <img src={`${HTML_ASSETS_URL}assets/images/icon/user-icon.svg`} alt="user" />
                                    </span>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-6">
                                <button
                                    className="btn w-100 mb-3 search-btn"

                                    onClick={handleSearch}
                                    disabled={Loading}
                                >
                                    {Loading ? 'SEARCHING...' : 'Search'}
                                </button>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-6">
                                <button
                                    className="btn w-100 mb-3 clear-btn"

                                    onClick={handleClear}
                                    disabled={Loading && !FormData.name && !hasSearched}
                                >
                                    Refresh
                                </button>
                            </div>
                        </div>
                    </div>

                    {hasSearched && (
                        AlumniData && AlumniData.length > 0 ? (
                            AlumniData.map((alumni, index) => (
                                <div key={alumni.id || index} className="alumni-result-card mb-4">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <h4 className="section-title">{alumni.first_name} {alumni.last_name}</h4>
                                        <span className="designation btn-warning px-4">{alumni.designation || 'Member'}</span>
                                    </div>
                                    <hr />
                                    <div className="row g-4 info-grid">
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="info-item">
                                                <span className="icon">
                                                    <img src={`${HTML_ASSETS_URL}assets/images/icon/branch-02.svg`} alt="branch" />
                                                    <p className="label">Discipline:</p>
                                                </span>
                                                <p className="value">{alumni.discipline || 'NOT FOUND'}</p>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="info-item">
                                                <span className="icon">
                                                    <img src={`${HTML_ASSETS_URL}assets/images/icon/calender-icon.svg`} alt="calendar" />
                                                    <p className="label">Year of passing:</p>
                                                </span>
                                                <p className="value">
                                                    {alumni.passing_year || 'NOT FOUND'}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="info-item">
                                                <span className="icon">
                                                    <img src={`${HTML_ASSETS_URL}assets/images/icon/phone-icon-02.svg`} alt="phone" />
                                                    <p className="label">Phone no:</p>
                                                </span>
                                                <p className="value">
                                                    <span style={{ filter: !store_data?.is_login ? "blur(4px)" : "" }}>
                                                        {alumni.mobile_number || 'NOT FOUND'}
                                                    </span>
                                                    {!store_data?.is_login && (
                                                        <button className="btn btn-sm show-btn" data-bs-toggle="modal" data-bs-target="#loginModal">Show</button>
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="info-item">
                                                <span className="icon">
                                                    <img src={`${HTML_ASSETS_URL}assets/images/icon/email-icon-02.svg`} alt="email" />
                                                    <p className="label">Email id:</p>
                                                </span>
                                                <p className="value">
                                                    <span style={{ filter: !store_data?.is_login ? "blur(4px)" : "" }}>
                                                        {alumni.email_id || 'NOT FOUND'}
                                                    </span>
                                                    {!store_data?.is_login && (
                                                        <button className="btn btn-sm show-btn" data-bs-toggle="modal" data-bs-target="#loginModal">Show</button>
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                     
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="info-item">
                                                <span className="icon">
                                                    <img src={`${HTML_ASSETS_URL}assets/images/icon/spouse-icon.svg`} alt="spouse" />
                                                    <p className="label">Name of spouse:</p>
                                                </span>
                                                <p className="value">
                                                    <span style={{ filter: !store_data?.is_login ? "blur(4px)" : "" }}>
                                                        {alumni.spouse_name || 'NOT FOUND'}
                                                    </span>
                                                    {!store_data?.is_login && (
                                                        <button className="btn btn-sm show-btn" data-bs-toggle="modal" data-bs-target="#loginModal">Show</button>
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-4 col-sm-6">
                                            <div className="info-item">
                                                <span className="icon">
                                                    <img src={`${HTML_ASSETS_URL}assets/images/icon/dob-icon.svg`} alt="dob" />
                                                    <p className="label">Birthday:</p>
                                                </span>
                                                <p className="value">
                                                    <span style={{ filter: !store_data?.is_login ? "blur(4px)" : "" }}>
                                                        {alumni.date_of_birth && alumni.date_of_birth !== 'Invalid date'
                                                            ? new Date(alumni.date_of_birth).toLocaleDateString('en-IN', { day: 'numeric', month: 'long' }).replace(/(\d+)/, (day) => {
                                                                const dayNum = parseInt(day);
                                                                const suffix = (dayNum % 10 === 1 && dayNum !== 11) ? 'st' : (dayNum % 10 === 2 && dayNum !== 12) ? 'nd' : (dayNum % 10 === 3 && dayNum !== 13) ? 'rd' : 'th';
                                                                return dayNum + suffix;
                                                            })
                                                            : 'NOT FOUND'}
                                                    </span>
                                                    {!store_data?.is_login && (
                                                        <button className="btn btn-sm show-btn" data-bs-toggle="modal" data-bs-target="#loginModal">Show</button>
                                                    )}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="text-center py-4">
                                <p className="text-muted">
                                    {SearchStatus?.msg || 'No alumni data to display. Please search to find alumni.'}
                                </p>
                            </div>
                        )
                    )}
                </div>
            </section>
        </>
    )
}
